const SITE = "https://www.universaltree.in";
const LOGO = `${SITE}/theuniversaltree-logo.jpeg`;

const DEFAULT_SERVICES = [
  { name: "AC Installation & Repair", category: "AC Services" },
  { name: "Plumbing Services", category: "Plumbing" },
  { name: "Electrical Services", category: "Electrical" },
  { name: "Deep Cleaning", category: "Cleaning" },
  { name: "Painting Services", category: "Painting" },
  { name: "Carpentry Services", category: "Carpentry" },
];

export default function JsonLd({ services } = {}) {
  const list = (services && services.length ? services : DEFAULT_SERVICES).map((s) => ({
    "@type": "Service",
    name: s.name,
    provider: { "@type": "Organization", name: "Universal Tree" },
    areaServed: "India",
  }));

  const data = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "Universal Tree",
        url: SITE,
        logo: LOGO,
        image: LOGO,
        description: "Home service marketplace connecting customers with verified professionals across India.",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          availableLanguage: ["English", "Hindi"],
        },
      },
      {
        "@type": "WebSite",
        url: SITE,
        name: "Universal Tree — Trusted Home Services Near You",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: `${SITE}/services?q={search_term_string}`,
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "LocalBusiness",
        name: "Universal Tree",
        url: SITE,
        image: LOGO,
        description: "Home service marketplace connecting customers with verified professionals for AC repair, plumbing, cleaning, painting & more.",
        priceRange: "$$",
        areaServed: "India",
      },
      {
        "@type": "ItemList",
        name: "Home Services",
        itemListElement: list.map((s, i) => ({
          "@type": "ListItem",
          position: i + 1,
          item: s,
        })),
      },
    ],
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );
}